import { CALL_API, Schemas } from '../../common/middleware/api';
import moment from 'moment';

export const CENTERS_REQUEST = 'CENTERS_REQUEST';
export const CENTERS_SUCCESS = 'CENTERS_SUCCESS';
export const CENTERS_FAILURE = 'CENTERS_FAILURE';

export const INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST = 'INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS = 'INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE = 'INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE';

export const WEEKLY_PROGRAM_REQUEST = 'WEEKLY_PROGRAM_REQUEST';
export const WEEKLY_PROGRAM_SUCCESS = 'WEEKLY_PROGRAM_SUCCESS';
export const WEEKLY_PROGRAM_FAILURE = 'WEEKLY_PROGRAM_FAILURE';

export const SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST = 'SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST';
export const SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS = 'SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS';
export const SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE = 'SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE';

export const WEEKLY_PROGRAM_ITEM_REQUEST = 'WEEKLY_PROGRAM_ITEM_REQUEST';
export const WEEKLY_PROGRAM_ITEM_SUCCESS = 'WEEKLY_PROGRAM_ITEM_SUCCESS';
export const WEEKLY_PROGRAM_ITEM_FAILURE = 'WEEKLY_PROGRAM_ITEM_FAILURE';

export const LESSONS_REQUEST = 'LESSONS_REQUEST';
export const LESSONS_SUCCESS = 'LESSONS_SUCCESS';
export const LESSONS_FAILURE = 'LESSONS_FAILURE';

export const SELECTED_CENTER_LESSONS_REQUEST = 'SELECTED_CENTER_LESSONS_REQUEST';
export const SELECTED_CENTER_LESSONS_SUCCESS = 'SELECTED_CENTER_LESSONS_SUCCESS';
export const SELECTED_CENTER_LESSONS_FAILURE = 'SELECTED_CENTER_LESSONS_FAILURE';

export const GRADES_REQUEST = 'GRADES_REQUEST';
export const GRADES_SUCCESS = 'GRADES_SUCCESS';
export const GRADES_FAILURE = 'GRADES_FAILURE';

export const TERMS_REQUEST = 'TERMS_REQUEST';
export const TERMS_SUCCESS = 'TERMS_SUCCESS';
export const TERMS_FAILURE = 'TERMS_FAILURE';

export const NEURO_INFO_REQUEST = 'NEURO_INFO_REQUEST';
export const NEURO_INFO_SUCCESS = 'NEURO_INFO_SUCCESS';
export const NEURO_INFO_FAILURE = 'NEURO_INFO_FAILURE';

export const WEEKLY_INFO_REQUEST = 'WEEKLY_INFO_REQUEST';
export const WEEKLY_INFO_SUCCESS = 'WEEKLY_INFO_SUCCESS';
export const WEEKLY_INFO_FAILURE = 'WEEKLY_INFO_FAILURE';

export const CENTER_TERMS_REQUEST = 'CENTER_TERMS_REQUEST';
export const CENTER_TERMS_SUCCESS = 'CENTER_TERMS_SUCCESS';
export const CENTER_TERMS_FAILURE = 'CENTER_TERMS_FAILURE';

export const CENTER_GRADES_REQUEST = 'CENTER_GRADES_REQUEST';
export const CENTER_GRADES_SUCCESS = 'CENTER_GRADES_SUCCESS';
export const CENTER_GRADES_FAILURE = 'CENTER_GRADES_FAILURE';

export const WORKSHOPS_REQUEST = 'WORKSHOPS_REQUEST';
export const WORKSHOPS_SUCCESS = 'WORKSHOPS_SUCCESS';
export const WORKSHOPS_FAILURE = 'WORKSHOPS_FAILURE';

export const WORKSHOP_FETCH_REQUEST = 'WORKSHOP_GET_REQUEST';
export const WORKSHOP_FETCH_SUCCESS = 'WORKSHOP_GET_SUCCESS';
export const WORKSHOP_FETCH_FAILURE = 'WORKSHOP_GET_FAILURE';

export const WORKSHOP_SESSIONS_REQUEST = 'WORKSHOP_SESSIONS_REQUEST';
export const WORKSHOP_SESSIONS_SUCCESS = 'WORKSHOP_SESSIONS_SUCCESS';
export const WORKSHOP_SESSIONS_FAILURE = 'WORKSHOP_SESSIONS_FAILURE';

export const loadCenters = () => ({
	[CALL_API]: {
		types: [CENTERS_REQUEST, CENTERS_SUCCESS, CENTERS_FAILURE],
		endpoint: 'api/centers',
		schema: Schemas.CENTER_ARRAY
	}
});

export const loadIndividualConsultationSchedule = (centerId, childId, from, to) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST, INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS, INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE],
		endpoint: `api/centers/${centerId}/individualConsultationSchedule`,
		request: { childId, from, to },
		schema: Schemas.INDIVIDUAL_CONSULTATION_SCHEDULE_ARRAY
	},
	childId,
	centerId
});

export const loadWeeklyProgram = (centerId, termId, gradeIds, lessonTypes, isSelectedCenter = false) => ({
	[CALL_API]: {
		types: isSelectedCenter
			? [SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST, SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS, SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE]
			: [WEEKLY_PROGRAM_REQUEST, WEEKLY_PROGRAM_SUCCESS, WEEKLY_PROGRAM_FAILURE],
		endpoint: `api/centers/${centerId}/program`,
		request: { termId, gradeIds, lessonTypes },
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const fetchWeeklyProgramItem = (centerId, weeklyProgramItemId) => (dispatch, getState) => {
	const weeklyProgramItem = getState().entities.weeklyProgram[weeklyProgramItemId];
	if (weeklyProgramItem) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [WEEKLY_PROGRAM_ITEM_REQUEST, WEEKLY_PROGRAM_ITEM_SUCCESS, WEEKLY_PROGRAM_ITEM_FAILURE],
			endpoint: `api/centers/${centerId}/program/${weeklyProgramItemId}`,
			schema: Schemas.WEEKLY_PROGRAM_ITEM
		}
	});
};

export const loadLessons = (centerId, termId, gradeIds, from, to, lessonTypes, isSelectedCenter = false) => ({
	[CALL_API]: {
		types: isSelectedCenter
			? [SELECTED_CENTER_LESSONS_REQUEST, SELECTED_CENTER_LESSONS_SUCCESS, SELECTED_CENTER_LESSONS_FAILURE]
			: [LESSONS_REQUEST, LESSONS_SUCCESS, LESSONS_FAILURE],
		endpoint: `api/centers/${centerId}/lessons`,
		request: { termId, gradeIds, from, to, lessonTypes },
		schema: Schemas.LESSON_ARRAY
	}
});

export const loadTermsByCenter = (centerId) => (dispatch, getState) => {
	const center = getState().entities.centers[centerId];
	if (center && center.terms) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [CENTER_TERMS_REQUEST, CENTER_TERMS_SUCCESS, CENTER_TERMS_FAILURE],
			endpoint: `api/centers/${centerId}/terms`,
			schema: Schemas.CENTER
		}
	});
};

export const loadGrades = () => ({
	[CALL_API]: {
		types: [GRADES_REQUEST, GRADES_SUCCESS, GRADES_FAILURE],
		endpoint: 'api/grades',
		schema: Schemas.GRADE_ARRAY
	}
});

export const loadGradesByCenter = (centerId) => (dispatch, getState) => {
	const center = getState().entities.centers[centerId];
	if (center && center.grades) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [CENTER_GRADES_REQUEST, CENTER_GRADES_SUCCESS, CENTER_GRADES_FAILURE],
			endpoint: `api/centers/${centerId}/grades`,
			schema: Schemas.CENTER
		}
	});
};

export const fetchGradeNeurologicalInfo = (slug) => (dispatch, getState) => {
	// check if neuro info is already loaded for this grade
	const gradeInState = getGradeBySlug(getState().entities.grades, slug);
	if (gradeInState && gradeInState.neurologicalInfo) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [NEURO_INFO_REQUEST, NEURO_INFO_SUCCESS, NEURO_INFO_FAILURE],
			endpoint: `api/grades/${slug}/neurologicalInfo`,
			schema: Schemas.GRADE
		}
	});
};

export const fetchWeeklyInfo = (gradeId, weekNumber, programId, lessonDate) => (dispatch, getState) => {
	const weeklyInfo = getState().entities.weeklyInfos[`${gradeId}|${weekNumber}`];
	if (weeklyInfo) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [WEEKLY_INFO_REQUEST, WEEKLY_INFO_SUCCESS, WEEKLY_INFO_FAILURE],
			endpoint: `api/weeklyInfo`,
			method: 'POST',
			request: { programId, lessonDate, gradeId },
			schema: Schemas.WEEKLY_INFO
		}
	});
};

export const loadTerms = () => ({
	[CALL_API]: {
		types: [TERMS_REQUEST, TERMS_SUCCESS, TERMS_FAILURE],
		endpoint: 'api/terms',
		schema: Schemas.TERM_ARRAY
	}
});

export const getDefaultActiveTerm = (terms) => {
	// the first one marked as active, sorted by StartDate asc
	return Object.values(terms).sort((a, b) => moment(a.startDate) - moment(b.startDate)).find(term => term.active);
};

export const getGradeBySlug = (grades, slug) => {
	const gradeId = Object.keys(grades).find(key => grades[key].slug === slug);
	return grades[gradeId];
};

export const getTermPeriodByCenter = (centers, centerId, termId) => {
	const center = centers[centerId];
	if (center && center.terms) {
		return center.terms.find(x => x.id === termId);
	}

	return null;
};

export const loadWorkshops = (centerId) => ({
	[CALL_API]: {
		types: [WORKSHOPS_REQUEST, WORKSHOPS_SUCCESS, WORKSHOPS_FAILURE],
		endpoint: `api/centers/${centerId}/workshops`,
		schema: Schemas.WORKSHOP_ARRAY
	},
	centerId
});

export const fetchWorkshop = (centerId, workshopId) => (dispatch, getState) => {
	const workshop = getState().entities.workshops[workshopId];
	if (workshop) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [WORKSHOP_FETCH_REQUEST, WORKSHOP_FETCH_SUCCESS, WORKSHOP_FETCH_FAILURE],
			endpoint: `api/centers/${centerId}/workshops/${workshopId}`,
			schema: Schemas.WORKSHOP
		}
	});
};

export const loadWorkshopSessions = (centerId, workshopId) => ({
	[CALL_API]: {
		types: [WORKSHOP_SESSIONS_REQUEST, WORKSHOP_SESSIONS_SUCCESS, WORKSHOP_SESSIONS_FAILURE],
		endpoint: `api/centers/${centerId}/workshops/${workshopId}/sessions`,
		schema: Schemas.WORKSHOP_SESSION_ARRAY
	},
	workshopId
});